import { createContext } from 'react';
import { AuthState } from 'services/auth';

export const SessionContext = createContext<AuthState | undefined>(undefined);
